import WtFormInputs from './WtFormInputs'
import WtFormButtons from './WtFormButtons'
import WtFormTable from './WtFormTable'
import WtFormTableList from './WtFormTableList'
import WtFormPagination from './WtFormPagination'
import WtDetailPage from './WtDetailPage'
import WtDetailFormSection from './WtDetailFormSection'
import WtDetailFormBlankSection from './WtDetailFormBlankSection'
import WtDetailBlankSection from './WtDetailBlankSection'
import WtSection from './WtSection'
import WtDialog from './WtDialog'
import WtDetailFormButtons from './WtDetailFormButtons'
import WtAuth from './WtAuth'
import WtUpload from './WtUpload'
import WtTinymce from './WtTinymce'
import NormalTable from './NormalTable/index.vue'
import PageComponent from './PageComponent/index.vue'
import WtReadonlyFormSection from './WtReadonlyFormSection/index.vue'

export default {
  WtFormInputs,
  WtFormButtons,
  WtFormTable,
  WtFormTableList,
  WtFormPagination,
  WtDetailPage,
  WtDetailFormSection,
  WtDetailFormBlankSection,
  WtDetailBlankSection,
  WtSection,
  WtDialog,
  WtDetailFormButtons,
  WtAuth,
  WtUpload,
  WtTinymce,
  NormalTable,
  PageComponent,
  WtReadonlyFormSection
}
